import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { APP_TITLE, CANCEL_AND_LOGOUT, CHANGE_DATABASE, CHANGE_PASSWORD, CONNECT, CONNECTED_TO_DATASERVICE, CONNECTION_NOT_WORKING, CONNECTION_SUCESSFUL, CONTINUE, EMAIL, ERROR, LOGIN, NEW_PASSWORD, PASSWORD, PASSWORD_CHANGED, SELECT_DATABASE, SUBMIT, SUCCESS, TRY_AGAIN, TRY_CONNECT_AGAIN, USER } from '../../shared/strings';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { SharedService } from '../../services/shared.service';
import { LoginResponse } from '../../interfaces/LoginResponse';
import { Router } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { NotifyDialogService } from '../../services/notify-dialog.service';
import { LoginEnum } from '../../enums/LoginEnums';
import { DataService } from '../../interfaces/DataService';
import {MatDividerModule} from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { getAllDatabaseInfo } from '../../utils/RequestUtils';
import { BeNeo4jService } from '../../services/be-neo4j.service';
import { COptionsResponse } from '../../clases/COptionsResponse';
import { SpaceButtonDirective } from '../../directives/space-button.directive';
import { INeo4jData } from '../../interfaces/INeo4jData';
import { LoginUiContainerComponent } from '../../components/login-ui-container/login-ui-container.component';
import { ChangeDatabaseComponent } from '../../components/change-database/change-database.component';
import { ConnectDatabaseFunction } from '../../types/ConnectDatabaseFunction';


@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatDividerModule,
    MatListModule,
    MatCheckboxModule,
    SpaceButtonDirective,
    LoginUiContainerComponent,
    ChangeDatabaseComponent
  ],
  providers: [
    AuthService
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {

  constructor(
    private authService: AuthService,
    private sharedService: SharedService,
    private notifyDialogService: NotifyDialogService,
    private beNeo4jService: BeNeo4jService,
    private router: Router
  ){}

  APP_TITLE = APP_TITLE;
  USER = USER;
  EMAIL = EMAIL;
  PASSWORD = PASSWORD;
  NEW_PASSWORD = NEW_PASSWORD;
  SUBMIT = SUBMIT;
  LOGIN = LOGIN;
  SELECT_DATABASE = SELECT_DATABASE;
  CHANGE_DATABASE = CHANGE_DATABASE;
  CHANGE_PASSWORD = CHANGE_PASSWORD;
  PASSWORD_CHANGED = PASSWORD_CHANGED;
  SUCCESS = SUCCESS;
  ERROR = ERROR;
  CANCEL_AND_LOGOUT = CANCEL_AND_LOGOUT;
  CONNECTION_SUCESSFUL = CONNECTION_SUCESSFUL;
  CONNECTED_TO_DATASERVICE = CONNECTED_TO_DATASERVICE;
  CONTINUE= CONTINUE;
  CONNECTION_NOT_WORKING = CONNECTION_NOT_WORKING;
  TRY_CONNECT_AGAIN = TRY_CONNECT_AGAIN;
  TRY_AGAIN = TRY_AGAIN;

  sucessDatabase: string = CONNECTED_TO_DATASERVICE;
  failDatabase: string = TRY_CONNECT_AGAIN;

  isLoading: boolean = false;

  current_phase:LoginEnum  = LoginEnum.LOGIN_WINDOW;
  data_services: DataService[] = [];

  submitForm = new FormGroup({
    userId: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
  });

  changePassword = new FormGroup({
    password: new FormControl('', [Validators.required]),
  });

  hide = signal(true);

  onHide(event: MouseEvent) {
    this.hide.set(!this.hide());
    event.stopPropagation();
  }

  forgotPassword(): void {}

  login(){
    if(!this.submitForm.valid) return;
    this.isLoading = true;
    this.authService.login(this.submitForm.value).subscribe({
      next: (res: LoginResponse)=>{
        this.isLoading = false;
        this.sharedService.access_token = res.result.token;
        let updatePassword = res.result.updatePassword;
        if(updatePassword){
          this.current_phase = LoginEnum.CHANGE_PASSWORD;
          return;
        }
        this.sharedService.refresh_token = res.result.token_renew;
        this.sharedService.data_services = res.result.dataservices;
        this.sharedService.user_attr = res.result.user_attr;
        this.data_services = res.result.dataservices;
        this.current_phase = LoginEnum.SELECT_DATABASE;
      },
      error: (error: any)=>{
        this.isLoading = false;
      }
    });
  }

  onChangePassword(){
    if(!this.changePassword.valid) return;
    this.isLoading = true;
    let formValues = this.submitForm.value;
    let changePassword = this.changePassword.value.password;
    let json = {
      userId: formValues.userId,
      password: formValues.password,
      new_password: changePassword
    };
    this.authService.changePassword(json).subscribe({
      next: ()=>{
        this.isLoading = false;
        this.logout();
        this.notifyDialogService.openDialog(SUCCESS, PASSWORD_CHANGED);
      },
      error: (err: any)=>{
        this.isLoading = false;
      }
    });
  }

  connectToDatabase: ConnectDatabaseFunction = (data_service: DataService)=> {
    this.sharedService.data_service = data_service;
    this.isLoading = true;
    getAllDatabaseInfo(this.beNeo4jService).subscribe({
      next: ([labels, relationships, schemaTree]) => {
        let connection = {
          DBrelations: (relationships as any).result,
          DBlabels: (labels as any).result,
          hierarchy: [],
          dataService: this.sharedService.data_service!,
          schemaTree: schemaTree,
        } as INeo4jData;

        this.sharedService.default_database_connection = connection;
        this.sucessDatabase = this.CONNECTED_TO_DATASERVICE.replace("${name}", data_service!.data_service_name);
        this.isLoading = false;
        this.current_phase = LoginEnum.CONNECTION_SUCESS;
      },
      error: (err) => {
        this.failDatabase = this.TRY_CONNECT_AGAIN.replace("${name}", data_service!.data_service_name);
        this.isLoading = false;
        this.current_phase = LoginEnum.CONNECTION_FAILED;
      },
    });
  }

  logout = ()=>{
    this.sharedService.clearTokens();
    this.current_phase = LoginEnum.LOGIN_WINDOW;
    this.submitForm.reset();
    this.changePassword.reset();
  }

  onConnectionFailed(){
    this.current_phase = LoginEnum.SELECT_DATABASE;
  }

  onConnectionSuccess(){
    this.router.navigate(['/']);
  }

  showLoginBanner = ()=>{
    return (
      this.current_phase === LoginEnum.LOGIN_WINDOW ||
      this.current_phase === LoginEnum.CHANGE_PASSWORD || 
      this.current_phase === LoginEnum.SELECT_DATABASE
    );
  }

}
